"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.columns = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lexico = new lexico_1.default();
exports.columns = [
    {
        id: 'cardName',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    flex: 3,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Card Name') }) }));
        },
    },
    {
        id: 'provider',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    flex: 3,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Provider') }) }));
        },
    },
    {
        id: 'lastFourDigits',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Last four digits') }) }));
        },
    },
    {
        id: 'currency',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Currency') }) }));
        },
    },
    {
        id: 'status',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    flex: 2,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Status') }) }));
        },
    },
    {
        id: 'adddress',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    flex: 2,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Billing address') }) }));
        },
    },
    {
        id: 'teams',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    flex: 2,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Teams') }) }));
        },
    },
    {
        id: 'details',
        ui() {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                    flex: 0.5,
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Details') }) }));
        },
    },
];
